jQuery(function() { 

    $('#program-filter-btn').on('click', function () {
        $('.filter-controls--filter-area').toggle();
        $(this).toggleClass('filter-active')
    })
});